import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App0 from './AppPFC';
import App1 from './AppPFCLS';
import App2 from './AppPoke';

import reportWebVitals from './reportWebVitals';
import {
  Routes,
  Route,
  Link,
  HashRouter 
} from "react-router-dom";

let t : JSX.Element =    
<table>
<thead>
    <tr>
        <th colSpan={2}>Scores</th>
    </tr>
</thead>
<tbody>
    <tr>
        <td>You</td>
        <td>Bot</td>
    </tr>
    <tr>
      <td id ="scP">0</td>
      <td id = "scC">0</td>
    </tr>
</tbody>
</table>

ReactDOM.render(
  <HashRouter>
    <Routes>
      <Route path="/" element= {
          <div className="App">
            <header className="App-header">
      
            </header>
            <div>
              <h1 >Choose A Game</h1>
            </div>
            <nav>
              <Link to="/app0">  <img className = "img0" src={require('../src/assets/img/PFC.jpg')}></img></Link>
              <Link to="/app1"><img className = "img0"  src={require('../src/assets/img/PFCLS.jpg')}></img></Link>
              <Link to="/app2"><img className = "img0"  src={require('../src/assets/img/poke.jpg')}></img></Link>
            </nav>
        </div>
        }
          />
      <Route path="/app0" element={
      <div >
        <div >{<App0/>}</div>
        <div>{t}</div>
    </div>
  }/>
      <Route path="/app1" element={
      <div >
        <div >{<App1/>}</div>
        <div >{t}</div>
    </div>} />
      <Route path="/app2" element={
         <div >
        <div >{<App2/>}</div>
        <div >{t}</div>
    </div>} />

    </Routes>
  </HashRouter>,
  document.getElementById("root"),
  
);
reportWebVitals();